import Actions from './Actions';
import Body from './Body';
import CloseButton from './CloseButton';
import Content from './Content';
import { Form } from './Form';
import Header from './Header';
import ResourceGuard from './ResourceGuard';
import Root, {
  type ControlledDialogProps,
  type StaticDialogProps,
} from './Root';
import SubmitError from './SubmitError';
import Subtitle from './Subtitle';
import Title from './Title';
import Trigger from './Trigger';
import TriggerButtonIcon from './TriggerButtonIcon';

export type { ControlledDialogProps as MuiDialogControlledProps };
export type { StaticDialogProps as MuiDialogStaticProps };

/** @deprecated Legacy MUI copy — migrate consumers to the Encore DialogComposite and delete. */
export const DialogCompositeMui = {
  Root,
  Content,
  Form,
  Header,
  Title,
  Subtitle,
  CloseButton,
  Body,
  Actions,
  ResourceGuard,
  Trigger,
  TriggerButtonIcon,
  SubmitError,
};
